import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { PaymentStatus } from '../lims-types';

const STATUS_COLORS: Record<PaymentStatus, string> = {
  draft: 'gray',
  issued: 'yellow',
  balanced: 'green',
  cancelled: 'red',
};

interface PaymentStatusBadgeProps {
  status: PaymentStatus;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export const PaymentStatusBadge = ({
  status,
  size = 'sm',
}: PaymentStatusBadgeProps) => {
  const { t } = useTranslation('lims');

  return (
    <Badge color={STATUS_COLORS[status] || 'gray'} variant="light" size={size}>
      {t(`payment.statuses.${status}`)}
    </Badge>
  );
};
